export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export const PPDB_ENDPOINTS = {
    REGISTER: `${API_URL}/ppdb`,
    DETAILS: `${API_URL}/ppdb/details`,
};

export const SCHOOL_ENDPOINTS = {
    GET_DATA: `${API_URL}/school`,
};